import { ApiBase } from "~/extensions/api";
import { Login } from "./commands/Login";
import { MTLoginCommand } from "./commands/MTLoginCommand";
import { ImpersonationCommand } from "./commands/ImpersonationCommand";
import { encryptData } from "~/extensions/utils/EncryptData";
import { commonStore } from "~/store/CommonStore";
export class AuthApi extends ApiBase {
    async login(data) {
        try {
            const password = await encryptData(commonStore.publicKey, data.password);
            let command = new Login(data, password);
            return await this.request(command);
        }
        finally {
            await this.api.antiForgery.refresh();
        }
    }
    async mtLogin(model) {
        try {
            let command = new MTLoginCommand(model);
            return await this.request(command);
        }
        finally {
            await this.api.antiForgery.refresh();
        }
    }
    async impersonation(nyukyokeiyakuNo, userCd, lifeKainNo) {
        try {
            let command = new ImpersonationCommand(nyukyokeiyakuNo, userCd, lifeKainNo);
            return await this.request(command);
        }
        finally {
            await this.api.antiForgery.refresh();
        }
    }
    async endImpersonation() {
        try {
            await this.api.post("auth/impersonation/end");
            return;
        }
        finally {
            await this.api.antiForgery.refresh();
        }
    }
    user() {
        return this.api.get("auth/user");
    }
    async logout() {
        await this.api.get("auth/logout");
        await this.api.antiForgery.refresh();
    }
    passwordReissue(command) {
        return this.request(command);
    }
    validateCodePasswordReissue(command) {
        return this.request(command);
    }
    async token() {
        try {
            return await this.api.post("auth/token");
        }
        finally {
            await this.api.antiForgery.refresh();
        }
    }
    loadAnnounceRangeText() {
        return this.api.get("message/login/announce/range");
    }
}
